import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
    selector   : 'fuse-confirm-dialog',
    templateUrl: './confirm-dialog3.component.html',
    styleUrls  : ['./confirm-dialog3.component.scss']
})
export class FuseConfirmDialog3Component
{
    public confirmMessage: string;

    constructor(public dialogRef: MatDialogRef<FuseConfirmDialog3Component>)
    {
    }

}
